"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AppLayout_1 = __importDefault(require("@/Layouts/AppLayout"));
var react_1 = __importDefault(require("react"));
var inertia_react_1 = require("@inertiajs/inertia-react");
var ej2_react_grids_1 = require("@syncfusion/ej2-react-grids");
require("@syncfusion/ej2/tailwind.css");
require("@syncfusion/ej2-base/styles/tailwind.css");
require("@syncfusion/ej2-react-grids/styles/tailwind.css");
var abn_1 = require("@/utils/abn");
var page_1 = require("@syncfusion/ej2-grids/src/grid/actions/page");
// @ts-ignore
var xero_svg_1 = __importDefault(require("@/assets/xero.svg"));
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var Button_1 = __importDefault(require("@/Jetstream/Button"));
var inertia_1 = require("@inertiajs/inertia");
var ej2_react_inputs_1 = require("@syncfusion/ej2-react-inputs");
var Contacts = /** @class */ (function (_super) {
    __extends(Contacts, _super);
    function Contacts(props) {
        var _this = _super.call(this, props) || this;
        _this.handleActionBegin = function (args) {
            if (args.requestType === 'beginEdit') {
                var rowData = args.rowData;
                if (rowData === null || rowData === void 0 ? void 0 : rowData.guid) {
                    // suppress the edit dialog / inline editor
                    args.cancel = true;
                }
            }
        };
        _this.gridToolbarOptions = [
            {
                text: 'Add Contact',
                id: 'add',
                click: function () {
                    _this.setState({ isOpen: true, error: '', showValidation: false });
                },
            },
        ];
        _this.sourceTemplate = function (row) {
            var isXero = !!row.guid;
            return (react_1.default.createElement("span", { className: "inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold ".concat(isXero ? 'bg-blue-50 text-blue-700' : 'bg-slate-100 text-slate-700') },
                isXero && react_1.default.createElement("img", { src: xero_svg_1.default, alt: "", className: "h-4 w-4" }),
                isXero ? 'Xero' : 'Manual'));
        };
        _this.invoicesTemplate = function (row) {
            if (!row.id) {
                return react_1.default.createElement("span", { className: "text-gray-400" }, "N/A");
            }
            return (react_1.default.createElement(inertia_react_1.InertiaLink, { href: "/contacts/".concat(row.id, "/invoices"), className: "text-blue-600 hover:text-blue-800" }, "View"));
        };
        _this.taxNumberTemplate = function (row) {
            return react_1.default.createElement("span", null, (0, abn_1.formatABN)(row.tax_number));
        };
        _this.getFilteredContacts = function () {
            var contacts = _this.props.contacts || [];
            var normalizedQuery = _this.state.query.trim().toLowerCase();
            var matchesQuery = function (contact) {
                if (!normalizedQuery) {
                    return true;
                }
                var name = (contact.name || '').toLowerCase();
                var taxNumber = (contact.tax_number || '').toLowerCase();
                return name.includes(normalizedQuery) || taxNumber.includes(normalizedQuery);
            };
            return contacts.filter(function (contact) {
                if (!matchesQuery(contact)) {
                    return false;
                }
                if (_this.state.filter === 'xero') {
                    return !!contact.guid;
                }
                if (_this.state.filter === 'manual') {
                    return !contact.guid;
                }
                return true;
            });
        };
        _this.closeModal = function () {
            _this.setState({
                isOpen: false,
                showValidation: false,
            });
        };
        _this.save = function () {
            if (_this.form.name && _this.form.tax_number) {
                inertia_1.Inertia.post('/contacts', {
                    name: _this.form.name,
                    tax_number: _this.form.tax_number,
                });
                _this.setState({
                    isOpen: false,
                    error: '',
                    showValidation: false,
                });
            }
            else {
                _this.setState({
                    error: 'Name and ABN required!',
                    showValidation: true,
                });
            }
            // if (this.form.points && this.form.contact_id && this.form.reward_id) {
            // Inertia.post('/points', {
            //   id: null,
            //   points: this.form.points,
            //   statement_text: 'Added points',
            //   contact_id: this.form.contact_id,
            //   reward_id: this.form.reward_id,
            // });
            // keep modal open on validation error so users can fix inputs
            // } else {
            //   this.setState({
            //     error: 'Missing Contact or Reward with a valid points!',
            //   });
            // }
        };
        _this.handleChange = function (event) {
            switch (event.target.id) {
                case 'name':
                    _this.form.name = event.target.value;
                    break;
                case 'tax_number':
                    _this.form.tax_number = event.target.value;
                    break;
            }
            _this.setState(function (state) { return (__assign({}, state)); });
        };
        _this.state = {
            isOpen: false,
            error: '',
            showValidation: false,
            filter: 'all',
            query: '',
        };
        _this.form = { name: null, tax_number: null };
        return _this;
    }
    Contacts.prototype.componentDidMount = function () {
        var _a, _b;
        var filter = (_a = localStorage.getItem('contacts.filter')) !== null && _a !== void 0 ? _a : 'all';
        var query = (_b = localStorage.getItem('contacts.query')) !== null && _b !== void 0 ? _b : '';
        var normalizedFilter = filter === 'all' || filter === 'xero' || filter === 'manual' ? filter : 'all';
        if (normalizedFilter !== this.state.filter || query !== this.state.query) {
            this.setState({
                filter: normalizedFilter,
                query: query,
            });
        }
    };
    Contacts.prototype.render = function () {
        var _this = this;
        var allContacts = this.props.contacts || [];
        var xeroCount = allContacts.filter(function (contact) { return !!contact.guid; }).length;
        var manualCount = allContacts.filter(function (contact) { return !contact.guid; }).length;
        var filteredContacts = this.getFilteredContacts();
        var gridExtras = {
            loadingIndicator: { indicatorType: 'Spinner' },
            emptyRecordTemplate: function () { return (react_1.default.createElement("span", { className: "text-gray-500" }, "No contacts found.")); },
        };
        return (react_1.default.createElement(AppLayout_1.default, { title: "Contacts", renderHeader: function () { return (react_1.default.createElement("div", { className: "flex flex-col gap-1" },
                react_1.default.createElement("p", { className: "text-xs uppercase tracking-[0.3em] text-green-500" }, "People"),
                react_1.default.createElement("h2", { className: "text-2xl font-semibold text-gray-900" }, "Contacts"),
                react_1.default.createElement("p", { className: "text-sm text-gray-500" },
                    allContacts.length,
                    " total \u00B7 ",
                    xeroCount,
                    " from Xero \u00B7 ",
                    manualCount,
                    " manual"))); } },
            react_1.default.createElement("div", { className: "py-12" },
                react_1.default.createElement("div", { className: "mx-auto sm:ps-6 lg:px-8" },
                    react_1.default.createElement("div", { className: "bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4" },
                        react_1.default.createElement("div", { className: "mb-4 flex flex-wrap items-center justify-between gap-3" },
                            react_1.default.createElement("div", { className: "flex items-center gap-2 text-sm" },
                                react_1.default.createElement("button", { type: "button", onClick: function () {
                                        localStorage.setItem('contacts.filter', 'all');
                                        _this.setState({ filter: 'all' });
                                    }, className: "rounded-full px-4 py-1.5 font-medium ".concat(this.state.filter === 'all'
                                        ? 'bg-green-600 text-white'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200') }, "All"),
                                react_1.default.createElement("button", { type: "button", onClick: function () {
                                        localStorage.setItem('contacts.filter', 'xero');
                                        _this.setState({ filter: 'xero' });
                                    }, className: "rounded-full px-4 py-1.5 font-medium ".concat(this.state.filter === 'xero'
                                        ? 'bg-green-600 text-white'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200') },
                                    "Xero (",
                                    xeroCount,
                                    ")"),
                                react_1.default.createElement("button", { type: "button", onClick: function () {
                                        localStorage.setItem('contacts.filter', 'manual');
                                        _this.setState({ filter: 'manual' });
                                    }, className: "rounded-full px-4 py-1.5 font-medium ".concat(this.state.filter === 'manual'
                                        ? 'bg-green-600 text-white'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200') },
                                    "Manual (",
                                    manualCount,
                                    ")")),
                            react_1.default.createElement("div", { className: "flex items-center gap-3" },
                                react_1.default.createElement(ej2_react_inputs_1.TextBoxComponent, { value: this.state.query, placeholder: "Search name or ABN", change: function (event) {
                                        var _a;
                                        var value = (_a = event.value) !== null && _a !== void 0 ? _a : '';
                                        localStorage.setItem('contacts.query', value);
                                        _this.setState({ query: value });
                                    } }),
                                react_1.default.createElement("button", { type: "button", onClick: function () {
                                        localStorage.removeItem('contacts.filter');
                                        localStorage.removeItem('contacts.query');
                                        _this.setState({ filter: 'all', query: '' });
                                    }, className: "rounded-full px-4 py-1.5 text-sm font-medium text-gray-600 hover:text-gray-900" }, "Clear filters"),
                                react_1.default.createElement("span", { className: "text-xs text-gray-500" },
                                    "Showing ",
                                    filteredContacts.length,
                                    " contacts"))),
                        react_1.default.createElement(ej2_react_grids_1.GridComponent, __assign({ id: "grid", key: "".concat(this.state.filter, "-").concat(this.state.query), dataSource: filteredContacts, toolbar: this.gridToolbarOptions }, gridExtras, { pageSettings: { pageSize: 25 }, allowPaging: true, allowSorting: true, allowFiltering: true, allowTextWrap: true, sortSettings: {
                                columns: [{ field: 'name', direction: 'Ascending' }],
                            }, editSettings: { allowEditing: true }, actionBegin: this.handleActionBegin, ref: function (g) { return (_this.gridInstance = g); } }),
                            react_1.default.createElement(ej2_react_grids_1.ColumnsDirective, null,
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "source", headerText: "Source", template: this.sourceTemplate, width: "120", allowFiltering: false, allowSorting: false }),
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "name", headerText: "Name" }),
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "tax_number", headerText: "ABN", template: this.taxNumberTemplate }),
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "invoices", headerText: "Invoices", template: this.invoicesTemplate, width: "120", allowFiltering: false, allowSorting: false })),
                            react_1.default.createElement(ej2_react_grids_1.Inject, { services: [page_1.Page, ej2_react_grids_1.Toolbar, ej2_react_grids_1.Sort, ej2_react_grids_1.Filter, ej2_react_grids_1.Edit] }))))),
            this.state.isOpen && (react_1.default.createElement("div", { className: "fixed z-10 inset-0 overflow-y-auto ease-out duration-400" },
                react_1.default.createElement("div", { className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" },
                    react_1.default.createElement("div", { className: "fixed inset-0 transition-opacity" },
                        react_1.default.createElement("div", { className: "absolute inset-0 bg-gray-500 opacity-75" }, "Title")),
                    react_1.default.createElement("span", { className: "hidden sm:inline-block sm:align-middle sm:h-screen" }),
                    react_1.default.createElement("div", { className: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full", role: "dialog", "aria-modal": "true", "aria-labelledby": "modal-headline" },
                        react_1.default.createElement("form", null,
                            react_1.default.createElement("div", { className: "grid grid-cols-6 gap-6 py-2 px-4 " },
                                react_1.default.createElement("div", { className: "col-span-12" },
                                    react_1.default.createElement(Label_1.default, null, "Add Contact")),
                                react_1.default.createElement("div", { className: "col-span-12" },
                                    react_1.default.createElement(Label_1.default, null, "Name"),
                                    react_1.default.createElement(ej2_react_inputs_1.TextBoxComponent, { id: "name", placeholder: "Enter Name", onChange: this.handleChange }),
                                    this.state.showValidation && !this.form.name && (react_1.default.createElement("p", { className: "mt-1 text-sm text-red-600" }, "Name is required."))),
                                react_1.default.createElement("div", { className: "col-span-12" },
                                    react_1.default.createElement(Label_1.default, null, "ABN"),
                                    react_1.default.createElement(ej2_react_inputs_1.TextBoxComponent, { id: "tax_number", placeholder: "Enter ABN", onChange: this.handleChange }),
                                    this.state.showValidation && !this.form.tax_number && (react_1.default.createElement("p", { className: "mt-1 text-sm text-red-600" }, "ABN is required."))),
                                react_1.default.createElement("div", { className: "col-span-12" },
                                    react_1.default.createElement("div", { className: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" },
                                        react_1.default.createElement("span", { className: "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto" },
                                            react_1.default.createElement(Button_1.default, { onClick: this.save, type: "button", disabled: !this.form.name || !this.form.tax_number, className: "inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5" }, "Save")),
                                        react_1.default.createElement("span", { className: "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto" },
                                            react_1.default.createElement(Button_1.default, { onClick: this.closeModal, type: "button", className: "inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5" }, "Cancel")),
                                        this.state.error && (react_1.default.createElement("span", { className: "p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800" }, this.state.error))))))))))));
    };
    return Contacts;
}(react_1.default.Component));
exports.default = Contacts;
